import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ModalPrintSuccessProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onYes: () => void;
}

const ModalPrintSuccessControInteressato = ({
  open,
  onClose,
  onYes,
}: ModalPrintSuccessProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        La stampa è stata effettuata correttamente?
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="primary" type="button" onClick={() => onYes()}>
          SI
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          NO
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalPrintSuccessControInteressato.displayName = 'Modal request certificate contro interessato';

export default ModalPrintSuccessControInteressato;
